/*
 * YourXI Bespoke XI wizard shell
 * --------------------------------------------------------------------------
 * window.YXIShell. Navigation, steps, collapsible extras, sticky preview,
 * bottom bar, toasts and a bottom sheet. Holds no product state: the wizard
 * owns the XI, the shell only lays it out. CSS prefix: yxs-
 * shell.css is injected from the same folder unless already linked.
 *
 * const shell = YXIShell.mount(rootEl, {
 *   steps: [{
 *     id, label,                     // 'players', 'Players'
 *     title, intro,                  // optional heading + one-line intro (title defaults to label)
 *     render(el, shell),             // core content, called once (and again on shell.rerender(id))
 *     sections: [{ id, label, hint, defaultOpen, render(el, shell),
 *                  summary(shell) -> string, when(shell) -> bool }],
 *     after(el, shell),              // optional content below the sections (order block on the last step)
 *     validate(shell) -> true | string | {ok, message, block},
 *     nextLabel                      // optional, defaults to 'Next: <next label>'
 *   }],
 *   toolbar: { undo, redo, surprise, share, save },   // each fn(shell); missing = button hidden
 *   preview: { tabs: [['print','Print'],['wall','On your wall']], onTab(id, shell) },
 *   finalAction: { label: 'Add to cart', run(shell) },
 *   tip: { step: 'players', text: 'Tap any shirt on the print to add a player.' },
 *   price: '£XX.XX', priceDetail: 'A3, black frame',
 *   brandHref: '/', storageKey: 'yxs', startStep: 0,
 *   onStepChange(id, prevId, shell)
 * });
 *
 * shell.previewEl / shell.previewMetaEl      slots for the live print and its caption
 * shell.go(idOrIndex) .next() .back() .current() -> {id, index}
 * shell.rerender(stepId)  shell.refresh()    (re-runs when() and summary())
 * shell.setSummary(stepId, sectionId, text)  shell.openSection(stepId, sectionId, open)
 * shell.setTool(name, {disabled, hidden})    shell.setPrice(price, detail)
 * shell.setDone(stepId, bool)                shell.setPreviewTab(id)
 * shell.toast(msg, {action: {label, run}, duration})
 * shell.sheet(contentElOrHtml, {title, actions: [{label, primary, onClick(close)}], foot, size: 'small', onClose})
 *   -> {el, body, close(), setTitle(t)}
 * shell.destroy()
 */
(function (root) {
  'use strict';

  var SCRIPT_SRC = (document.currentScript && document.currentScript.src) || '';
  var DESK = '(min-width: 960px)';
  var uid = 0;

  function injectCss() {
    if (!SCRIPT_SRC || document.querySelector('link[data-yxs], link[href*="shell.css"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.setAttribute('data-yxs', '');
    l.href = SCRIPT_SRC.replace(/shell(\.min)?\.js(\?.*)?$/, 'shell.css');
    document.head.appendChild(l);
  }

  var store = {
    get: function (k) { try { return JSON.parse(root.localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { root.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  };

  function reduced() { return root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function isDesk() { return root.matchMedia && root.matchMedia(DESK).matches; }

  var P = 'fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"';
  var ICON = {
    undo: '<svg viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg>',
    redo: '<svg viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13"/></svg>',
    surprise: '<svg viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><rect x="3.5" y="3.5" width="17" height="17"/><circle cx="8.5" cy="8.5" r="1.1" fill="currentColor"/><circle cx="15.5" cy="15.5" r="1.1" fill="currentColor"/><circle cx="12" cy="12" r="1.1" fill="currentColor"/></svg>',
    share: '<svg viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><path d="M12 3v12"/><path d="m7 8 5-5 5 5"/><path d="M5 13v8h14v-8"/></svg>',
    save: '<svg viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><rect x="3" y="5" width="18" height="14"/><path d="m3 7 9 6 9-6"/></svg>',
    chev: '<svg class="yxs-sec-chev" viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>',
    up: '<svg viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><path d="m6 15 6-6 6 6"/></svg>',
    close: '<svg viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    back: '<svg viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>',
    next: '<svg viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>',
    tick: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    eye: '<svg viewBox="0 0 24 24" ' + P + ' aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>'
  };
  var TOOLS = [
    ['undo', 'Undo', true, 'Undo (Ctrl or Cmd + Z)'],
    ['redo', 'Redo', true, 'Redo (Ctrl or Cmd + Shift + Z)'],
    ['surprise', 'Surprise me', false, 'Fill the XI with a random legends team'],
    ['share', 'Share', false, 'Share your XI'],
    ['save', 'Save', false, 'Email yourself a link to this XI']
  ];

  function h(tag, attrs, html) {
    var el = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (attrs[k] == null || attrs[k] === false) continue;
      if (k === 'class') el.className = attrs[k]; else el.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    }
    if (html != null) el.innerHTML = html;
    return el;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function typing(t) { return t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)); }
  function normValid(r) {
    if (r === true || r == null) return { ok: true };
    if (typeof r === 'string') return { ok: false, message: r, block: false };
    return { ok: !!r.ok, message: r.message || '', block: !!r.block };
  }

  function mount(rootEl, o) {
    injectCss();
    o = o || {};
    var KEY = o.storageKey || 'yxs';
    var steps = (o.steps || []).slice();
    var openState = store.get(KEY + ':open') || {};
    var done = {};
    var curIdx = -1;
    var tools = {};
    var cleanups = [];
    var shell = {};
    var layerOpen = 0;
    var id0 = 'yxs' + (++uid);

    rootEl.innerHTML = '';
    rootEl.classList.add('yxs');

    // ---- Header + toolbar ----
    var headWrap = h('div', { class: 'yxs-head-wrap' });
    var top = h('header', { class: 'yxs-top' });
    top.appendChild(h('a', { class: 'yxs-brand', href: o.brandHref || '/', 'aria-label': 'YourXI home' },
      root.YXI_LOGO ? '<img src="' + root.YXI_LOGO.black + '" alt="YourXI" style="display:block;height:24px;width:auto">' : 'YOUR<span>XI</span>'));
    var bar = h('div', { class: 'yxs-tools', role: 'toolbar', 'aria-label': 'Your XI tools' });
    var tb = o.toolbar || {};
    TOOLS.forEach(function (t, i) {
      if (typeof tb[t[0]] !== 'function') return;
      if (i === 2 && bar.childNodes.length) bar.appendChild(h('span', { class: 'yxs-tool-sep', 'aria-hidden': 'true' }));
      var b = h('button', { class: 'yxs-tool', type: 'button', 'data-tool': t[0], title: t[3], 'aria-label': t[1] },
        ICON[t[0]] + (t[2] ? '' : '<span class="yxs-tool-label">' + esc(t[1]) + '</span>'));
      b.addEventListener('click', function () { runTool(t[0]); });
      tools[t[0]] = { btn: b, disabled: t[0] === 'undo' || t[0] === 'redo', hidden: false };
      bar.appendChild(b);
    });
    top.appendChild(bar);
    headWrap.appendChild(top);

    // ---- Stepper ----
    var nav = h('nav', { class: 'yxs-stepper', 'aria-label': 'Steps' });
    var ol = h('ol');
    nav.appendChild(ol);
    headWrap.appendChild(nav);
    rootEl.appendChild(headWrap);

    // ---- Body: preview + main ----
    var body = h('div', { class: 'yxs-body' });
    var pv = h('aside', { class: 'yxs-pv', 'aria-label': 'Your print' });
    var pvTabs = null;
    if (o.preview && o.preview.tabs && o.preview.tabs.length > 1) {
      pvTabs = h('div', { class: 'yxs-pv-tabs', role: 'tablist', 'aria-label': 'Preview' });
      o.preview.tabs.forEach(function (t, i) {
        var b = h('button', { class: 'yxs-pv-tab', type: 'button', role: 'tab', 'data-tab': t[0], 'aria-selected': String(i === 0) }, esc(t[1]));
        b.addEventListener('click', function () { shell.setPreviewTab(t[0], true); });
        pvTabs.appendChild(b);
      });
      pv.appendChild(pvTabs);
    }
    var pvStage = h('div', { class: 'yxs-pv-stage', id: id0 + '-pv' });
    var pvClip = h('div', { class: 'yxs-pv-clip' });
    var previewEl = h('div', { class: 'yxs-pv-slot' });
    pvClip.appendChild(previewEl); pvStage.appendChild(pvClip); pv.appendChild(pvStage);
    var pvMeta = h('div', { class: 'yxs-pv-meta' });
    var previewMetaEl = h('div', { class: 'yxs-pv-meta-slot' });
    var pvToggle = h('button', { class: 'yxs-pv-toggle', type: 'button', 'aria-controls': id0 + '-pv', 'aria-expanded': 'true' }, '<span>Hide print</span>' + ICON.up);
    pvMeta.appendChild(previewMetaEl); pvMeta.appendChild(pvToggle); pv.appendChild(pvMeta);
    body.appendChild(pv);

    var main = h('main', { class: 'yxs-main', id: id0 + '-main' });
    body.appendChild(main);
    rootEl.appendChild(body);

    // ---- Bottom bar ----
    var bbar = h('div', { class: 'yxs-bar' });
    var prog = h('div', { class: 'yxs-bar-prog', 'aria-hidden': 'true' }, '<i></i>');
    var backBtn = h('button', { class: 'yxs-btn yxs-btn--ghost yxs-bar-back', type: 'button', 'aria-label': 'Back' }, ICON.back + '<span class="yxs-bar-back-label">Back</span>');
    var mid = h('div', { class: 'yxs-bar-mid' }, '<span class="yxs-bar-price"></span><span class="yxs-bar-detail"></span>');
    var nextBtn = h('button', { class: 'yxs-btn yxs-bar-next', type: 'button' });
    bbar.appendChild(prog); bbar.appendChild(backBtn); bbar.appendChild(mid); bbar.appendChild(nextBtn);
    main.appendChild(bbar);
    backBtn.addEventListener('click', function () { shell.back(); });
    nextBtn.addEventListener('click', function () { shell.next(); });

    var pill = h('button', { class: 'yxs-pill', type: 'button', 'aria-hidden': 'true', tabindex: '-1' }, ICON.eye + '<span>View print</span>');
    rootEl.appendChild(pill);
    var toasts = h('div', { class: 'yxs-toasts', role: 'status', 'aria-live': 'polite' });
    rootEl.appendChild(toasts);
    var live = h('div', { class: 'yxs-sr', 'aria-live': 'polite' });
    rootEl.appendChild(live);

    // ---- Build steps ----
    var S = steps.map(function (st, i) {
      var li = h('li');
      var sb = h('button', { class: 'yxs-step-btn', type: 'button' },
        '<span class="yxs-step-num">' + (i + 1) + '</span><span class="yxs-step-lab">' + esc(st.label) + '</span>');
      sb.addEventListener('click', function () { if (sb.getAttribute('aria-disabled') !== 'true') shell.go(i); });
      li.appendChild(sb); ol.appendChild(li);

      var sec = h('section', { class: 'yxs-step', 'data-step': st.id, hidden: true, 'aria-labelledby': id0 + '-h-' + st.id });
      sec.appendChild(h('p', { class: 'yxs-step-count' }, 'Step ' + (i + 1) + ' of ' + steps.length));
      sec.appendChild(h('h1', { class: 'yxs-step-title', id: id0 + '-h-' + st.id, tabindex: '-1' }, esc(st.title || st.label)));
      if (st.intro) sec.appendChild(h('p', { class: 'yxs-step-intro' }, esc(st.intro)));
      var tipSlot = h('div'); sec.appendChild(tipSlot);
      var core = h('div', { class: 'yxs-step-core' }); sec.appendChild(core);
      var secsWrap = null, secs = [];
      if (st.sections && st.sections.length) {
        secsWrap = h('div', { class: 'yxs-secs' });
        secs = st.sections.map(function (c) { return buildSection(st, c, secsWrap); });
        sec.appendChild(secsWrap);
      }
      var after = null;
      if (typeof st.after === 'function') { after = h('div', { class: 'yxs-step-after' }); sec.appendChild(after); }
      main.insertBefore(sec, bbar);
      return { def: st, li: li, btn: sb, el: sec, core: core, tipSlot: tipSlot, secs: secs, after: after, rendered: false };
    });

    function buildSection(st, c, wrap) {
      var k = st.id + '.' + c.id;
      var open = openState[k] != null ? !!openState[k] : !!c.defaultOpen;
      var bid = id0 + '-sb-' + st.id + '-' + c.id, pid = id0 + '-sp-' + st.id + '-' + c.id;
      var el = h('div', { class: 'yxs-sec', 'data-sec': c.id });
      var hd = h('h2', { class: 'yxs-sec-h' });
      var btn = h('button', { class: 'yxs-sec-btn', type: 'button', id: bid, 'aria-expanded': String(open), 'aria-controls': pid },
        '<span class="yxs-sec-txt"><span class="yxs-sec-label">' + esc(c.label) + '</span>' +
        (c.hint ? '<span class="yxs-sec-hint">' + esc(c.hint) + '</span>' : '') + '</span>' +
        '<span class="yxs-sec-sum is-empty"></span>' + ICON.chev);
      hd.appendChild(btn); el.appendChild(hd);
      var panel = h('div', { class: 'yxs-sec-panel' + (open ? ' is-open' : ''), id: pid, role: 'region', 'aria-labelledby': bid });
      var clip = h('div', { class: 'yxs-sec-clip' });
      var content = h('div', { class: 'yxs-sec-content' });
      clip.appendChild(content); panel.appendChild(clip); el.appendChild(panel);
      if (!open) content.setAttribute('inert', '');
      wrap.appendChild(el);
      var obj = { def: c, key: k, el: el, btn: btn, panel: panel, content: content, sum: btn.querySelector('.yxs-sec-sum'), open: open, rendered: false };
      btn.addEventListener('click', function () { setOpen(obj, !obj.open, true); });
      return obj;
    }

    function setOpen(s, open, user) {
      if (s.open === open) return;
      s.open = open;
      s.btn.setAttribute('aria-expanded', String(open));
      if (open) s.content.removeAttribute('inert'); else s.content.setAttribute('inert', '');
      s.panel.classList.add('is-anim');
      s.panel.classList.toggle('is-open', open);
      clearTimeout(s.t);
      s.t = setTimeout(function () { s.panel.classList.remove('is-anim'); }, reduced() ? 0 : 260);
      openState[s.key] = open;
      store.set(KEY + ':open', openState);
      if (open && user && !isDesk()) {
        // keep the opened section in view on phones
        setTimeout(function () {
          var r = s.el.getBoundingClientRect();
          if (r.top < 0 || r.top > root.innerHeight * .6) s.el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
        }, reduced() ? 0 : 200);
      }
    }

    function renderStep(x) {
      if (x.rendered) return;
      x.rendered = true;
      if (typeof x.def.render === 'function') x.def.render(x.core, shell);
      x.secs.forEach(function (s) {
        if (typeof s.def.render === 'function') s.def.render(s.content, shell);
        s.rendered = true;
      });
      if (x.after) x.def.after(x.after, shell);
    }

    function validateUpTo(i) {
      for (var j = 0; j < i; j++) {
        var v = normValid(S[j].def.validate ? S[j].def.validate(shell) : true);
        if (!v.ok && v.block) return { index: j, v: v };
      }
      return null;
    }

    function paintStepper() {
      var lock = null;
      S.forEach(function (x, i) {
        var cur = i === curIdx;
        x.btn.setAttribute('aria-current', cur ? 'step' : 'false');
        if (!cur) x.btn.removeAttribute('aria-current');
        x.li.classList.toggle('is-current', cur);
        if (lock === null && x.def.validate) {
          var v = normValid(x.def.validate(shell));
          if (!v.ok && v.block) lock = i;
        }
        var disabled = lock !== null && i > lock;
        x.btn.setAttribute('aria-disabled', String(disabled));
        x.btn.classList.toggle('is-done', !!done[x.def.id] && !cur);
        var num = x.btn.querySelector('.yxs-step-num');
        num.innerHTML = done[x.def.id] && !cur ? ICON.tick : String(i + 1);
        x.btn.setAttribute('aria-label', (i + 1) + ' ' + x.def.label + (done[x.def.id] ? ', done' : '') + (cur ? ', current step' : ''));
      });
    }

    function paintBar() {
      var last = curIdx === S.length - 1;
      backBtn.hidden = curIdx === 0;
      var st = S[curIdx].def;
      if (last && o.finalAction) nextBtn.innerHTML = esc(o.finalAction.label || 'Add to cart');
      else if (!last) nextBtn.innerHTML = '<span>' + esc(st.nextLabel || ('Next: ' + S[curIdx + 1].def.label)) + '</span>' + ICON.next;
      nextBtn.hidden = last && !o.finalAction;
      prog.firstChild.style.width = ((curIdx + 1) / S.length * 100) + '%';
    }

    function showTip(x) {
      x.tipSlot.innerHTML = '';
      if (!o.tip || o.tip.step !== x.def.id || store.get(KEY + ':tip')) return;
      var t = h('div', { class: 'yxs-tip', role: 'note' }, '<p>' + esc(o.tip.text) + '</p>');
      var c = h('button', { class: 'yxs-icon-btn', type: 'button', 'aria-label': 'Dismiss tip' }, ICON.close);
      c.addEventListener('click', function () { store.set(KEY + ':tip', 1); t.remove(); });
      t.appendChild(c); x.tipSlot.appendChild(t);
    }

    shell.go = function (target, opts) {
      var i = typeof target === 'number' ? target : S.findIndex(function (x) { return x.def.id === target; });
      if (i < 0 || i >= S.length) return false;
      var gate = validateUpTo(i);
      if (gate && (!opts || !opts.force)) {
        shell.toast(gate.v.message || 'Finish this step first.');
        if (gate.index !== curIdx) shell.go(gate.index, { force: true });
        return false;
      }
      var prev = curIdx >= 0 ? S[curIdx] : null;
      if (prev === S[i]) return true;
      if (prev) prev.el.hidden = true;
      curIdx = i;
      var x = S[i];
      renderStep(x);
      shell.refresh();
      x.el.hidden = false;
      // restart the entry animation
      x.el.style.animation = 'none'; void x.el.offsetWidth; x.el.style.animation = '';
      showTip(x);
      paintStepper(); paintBar();
      rootEl.setAttribute('data-step', x.def.id);
      if (prev) {
        var y = isDesk() ? 0 : Math.max(0, rootEl.getBoundingClientRect().top + root.scrollY);
        root.scrollTo({ top: y, behavior: 'auto' });
        var hd = x.el.querySelector('.yxs-step-title');
        try { hd.focus({ preventScroll: true }); } catch (e) { hd.focus(); }
        live.textContent = 'Step ' + (i + 1) + ' of ' + S.length + ', ' + x.def.label;
      }
      var cur = x.btn; if (cur.scrollIntoView && !isDesk()) { try { cur.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) { /* old Safari */ } }
      if (typeof o.onStepChange === 'function') o.onStepChange(x.def.id, prev ? prev.def.id : null, shell);
      return true;
    };

    shell.next = function () {
      var x = S[curIdx];
      var v = normValid(x.def.validate ? x.def.validate(shell) : true);
      if (!v.ok && v.block) { shell.toast(v.message || 'Finish this step first.'); return false; }
      if (curIdx === S.length - 1) {
        if (!o.finalAction) return false;
        var gate = validateUpTo(S.length);
        if (gate) { shell.toast(gate.v.message); shell.go(gate.index, { force: true }); return false; }
        o.finalAction.run(shell);
        return true;
      }
      if (!v.ok && v.message) shell.toast(v.message);
      done[x.def.id] = v.ok;
      return shell.go(curIdx + 1);
    };
    shell.back = function () { return curIdx > 0 ? shell.go(curIdx - 1, { force: true }) : false; };
    shell.current = function () { return { id: S[curIdx].def.id, index: curIdx }; };

    shell.rerender = function (stepId) {
      S.forEach(function (x) {
        if (stepId && x.def.id !== stepId) return;
        x.core.innerHTML = ''; x.secs.forEach(function (s) { s.content.innerHTML = ''; });
        if (x.after) x.after.innerHTML = '';
        x.rendered = false;
        if (S[curIdx] === x) renderStep(x);
      });
      shell.refresh();
    };

    shell.refresh = function () {
      S.forEach(function (x) {
        x.secs.forEach(function (s) {
          if (typeof s.def.when === 'function') s.el.hidden = !s.def.when(shell);
          if (typeof s.def.summary === 'function') paintSum(s, s.def.summary(shell));
        });
      });
      if (curIdx >= 0) { paintStepper(); paintBar(); }
    };

    function paintSum(s, text) {
      s.sum.textContent = text || 'Off';
      s.sum.classList.toggle('is-empty', !text);
    }
    function findSec(stepId, secId) {
      var x = S.find(function (q) { return q.def.id === stepId; });
      return x && x.secs.find(function (s) { return s.def.id === secId; });
    }
    shell.setSummary = function (stepId, secId, text) { var s = findSec(stepId, secId); if (s) paintSum(s, text); };
    shell.openSection = function (stepId, secId, open) {
      var s = findSec(stepId, secId); if (!s) return;
      setOpen(s, open !== false, false);
      if (open !== false) {
        if (S[curIdx].def.id !== stepId) shell.go(stepId);
        setTimeout(function () { s.el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); }, 50);
      }
    };
    shell.setDone = function (stepId, v) { done[stepId] = !!v; paintStepper(); };

    // ---- Toolbar ----
    function runTool(name) {
      var t = tools[name];
      if (!t || t.disabled || t.hidden) return;
      tb[name](shell);
    }
    shell.setTool = function (name, st) {
      var t = tools[name]; if (!t) return;
      if (st.disabled != null) { t.disabled = !!st.disabled; t.btn.setAttribute('aria-disabled', String(t.disabled)); }
      if (st.hidden != null) { t.hidden = !!st.hidden; t.btn.hidden = t.hidden; }
      // hide the separator if nothing sits to its right
      var sep = bar.querySelector('.yxs-tool-sep');
      if (sep) sep.hidden = !Array.prototype.some.call(bar.querySelectorAll('.yxs-tool'), function (b) {
        return !b.hidden && (b.dataset.tool === 'surprise' || b.dataset.tool === 'share' || b.dataset.tool === 'save');
      });
    };
    Object.keys(tools).forEach(function (n) { shell.setTool(n, { disabled: tools[n].disabled }); });

    function onKey(e) {
      if (layerOpen) return;
      var mod = e.metaKey || e.ctrlKey;
      if (!mod || typing(e.target)) return;
      var k = e.key.toLowerCase();
      if (k === 'z' && !e.shiftKey) { e.preventDefault(); runTool('undo'); }
      else if ((k === 'z' && e.shiftKey) || k === 'y') { e.preventDefault(); runTool('redo'); }
    }
    document.addEventListener('keydown', onKey);
    cleanups.push(function () { document.removeEventListener('keydown', onKey); });

    // ---- Price ----
    shell.setPrice = function (price, detail) {
      mid.querySelector('.yxs-bar-price').textContent = price || '';
      mid.querySelector('.yxs-bar-detail').textContent = detail || '';
    };
    shell.setPrice(o.price || '', o.priceDetail || '');

    // ---- Preview: tabs, collapse, pill ----
    shell.setPreviewTab = function (tabId, fromUser) {
      if (!pvTabs) return;
      Array.prototype.forEach.call(pvTabs.children, function (b) { b.setAttribute('aria-selected', String(b.dataset.tab === tabId)); });
      if (fromUser && o.preview.onTab) o.preview.onTab(tabId, shell);
    };
    var collapsed = !isDesk() && !!store.get(KEY + ':pvc');
    function setCollapsed(v) {
      collapsed = v;
      rootEl.classList.toggle('is-pv-collapsed', v);
      pvToggle.setAttribute('aria-expanded', String(!v));
      pvToggle.firstChild.textContent = v ? 'Show print' : 'Hide print';
      if (v) pvClip.setAttribute('inert', ''); else pvClip.removeAttribute('inert');
      store.set(KEY + ':pvc', v ? 1 : 0);
      updatePill();
    }
    pvToggle.addEventListener('click', function () { setCollapsed(!collapsed); });
    if (collapsed) setCollapsed(true);

    var pvVisible = true;
    function updatePill() {
      var on = !isDesk() && (collapsed || !pvVisible) && !layerOpen;
      pill.classList.toggle('is-on', on);
      pill.setAttribute('aria-hidden', String(!on));
      pill.tabIndex = on ? 0 : -1;
    }
    if ('IntersectionObserver' in root) {
      var io = new IntersectionObserver(function (ents) {
        pvVisible = ents[0].intersectionRatio > 0.25; updatePill();
      }, { threshold: [0, 0.25, 0.5] });
      io.observe(previewEl);
      cleanups.push(function () { io.disconnect(); });
    }
    pill.addEventListener('click', function () {
      if (collapsed) setCollapsed(false);
      var y = Math.max(0, pv.getBoundingClientRect().top + root.scrollY - 8);
      root.scrollTo({ top: y, behavior: reduced() ? 'auto' : 'smooth' });
    });

    // ---- Toast ----
    var toastT = null, toastEl = null;
    shell.toast = function (msg, opts) {
      opts = opts || {};
      if (toastEl) toastEl.remove();
      clearTimeout(toastT);
      var t = h('div', { class: 'yxs-toast' }, '<span>' + esc(msg) + '</span>');
      if (opts.action) {
        var a = h('button', { type: 'button' }, esc(opts.action.label));
        a.addEventListener('click', function () { opts.action.run(shell); hide(); });
        t.appendChild(a);
      }
      toasts.appendChild(t); toastEl = t;
      requestAnimationFrame(function () { t.classList.add('is-on'); });
      function hide() {
        t.classList.remove('is-on');
        setTimeout(function () { t.remove(); if (toastEl === t) toastEl = null; }, 250);
      }
      toastT = setTimeout(hide, opts.duration || (opts.action ? 5000 : 2600));
      return { close: hide };
    };

    // ---- Sheet ----
    shell.sheet = function (content, opts) {
      opts = opts || {};
      var tid = id0 + '-st' + (++uid);
      var lastFocus = document.activeElement;
      var layer = h('div', { class: 'yxs-layer' });
      var scrim = h('div', { class: 'yxs-scrim', 'aria-hidden': 'true' });
      var box = h('div', { class: 'yxs-sheet' + (opts.size === 'small' ? ' yxs-sheet--small' : ''), role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': tid });
      var grab = h('div', { class: 'yxs-sheet-grab', 'aria-hidden': 'true' });
      var head = h('div', { class: 'yxs-sheet-head' });
      var title = h('h2', { id: tid, tabindex: '-1' }, esc(opts.title || ''));
      var x = h('button', { class: 'yxs-icon-btn', type: 'button', 'aria-label': 'Close' }, ICON.close);
      head.appendChild(title); head.appendChild(x);
      var bd = h('div', { class: 'yxs-sheet-body' });
      if (typeof content === 'string') bd.innerHTML = content; else if (content) bd.appendChild(content);
      box.appendChild(grab); box.appendChild(head); box.appendChild(bd);
      var api;
      if (opts.foot || (opts.actions && opts.actions.length)) {
        var ft = h('div', { class: 'yxs-sheet-foot' });
        if (opts.foot) ft.appendChild(opts.foot);
        (opts.actions || []).forEach(function (a) {
          var b = h('button', { class: 'yxs-btn' + (a.primary ? '' : ' yxs-btn--ghost'), type: 'button' }, esc(a.label));
          b.addEventListener('click', function () { a.onClick ? a.onClick(api.close) : api.close(); });
          ft.appendChild(b);
        });
        box.appendChild(ft);
      }
      layer.appendChild(scrim); layer.appendChild(box);
      document.body.appendChild(layer);
      layerOpen++; updatePill();
      document.documentElement.classList.add('yxs-lock');
      var others = [rootEl];
      others.forEach(function (n) { n.setAttribute('inert', ''); });
      requestAnimationFrame(function () {
        layer.classList.add('is-open');
        var f = box.querySelector('[autofocus]') || (isDesk() && bd.querySelector('input,textarea,select')) || title; // phones: no keyboard jump
        try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
      });
      var closed = false;
      function close() {
        if (closed) return; closed = true;
        layer.classList.remove('is-open');
        document.removeEventListener('keydown', key, true);
        layerOpen--;
        if (!layerOpen) { document.documentElement.classList.remove('yxs-lock'); others.forEach(function (n) { n.removeAttribute('inert'); }); }
        updatePill();
        setTimeout(function () { layer.remove(); }, reduced() ? 0 : 320);
        if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* gone */ }
        if (typeof opts.onClose === 'function') opts.onClose();
      }
      function key(e) {
        if (!layer.isConnected || layer !== document.querySelector('.yxs-layer:last-of-type')) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(box.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'), function (n) { return !n.disabled && n.offsetParent !== null; });
        if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
      document.addEventListener('keydown', key, true);
      x.addEventListener('click', close);
      scrim.addEventListener('click', close);
      // drag the grab handle down to close (phones)
      var y0 = null;
      grab.addEventListener('pointerdown', function (e) { y0 = e.clientY; grab.setPointerCapture(e.pointerId); box.style.transition = 'none'; });
      grab.addEventListener('pointermove', function (e) { if (y0 == null) return; var d = Math.max(0, e.clientY - y0); box.style.transform = 'translateY(' + d + 'px)'; });
      function endDrag(e) {
        if (y0 == null) return; var d = e.clientY - y0; y0 = null;
        box.style.transition = ''; box.style.transform = '';
        if (d > 90) close();
      }
      grab.addEventListener('pointerup', endDrag); grab.addEventListener('pointercancel', endDrag);
      api = { el: box, body: bd, close: close, setTitle: function (t) { title.textContent = t; } };
      return api;
    };

    shell.destroy = function () {
      cleanups.forEach(function (f) { f(); });
      document.querySelectorAll('.yxs-layer').forEach(function (n) { n.remove(); });
      document.documentElement.classList.remove('yxs-lock');
      rootEl.innerHTML = ''; rootEl.classList.remove('yxs', 'is-pv-collapsed');
    };

    shell.el = rootEl;
    shell.previewEl = previewEl;
    shell.previewMetaEl = previewMetaEl;
    shell.steps = steps;

    var start = o.startStep != null ? o.startStep : 0;
    shell.go(start, { force: true });
    if (curIdx < 0) shell.go(0, { force: true });
    return shell;
  }

  root.YXIShell = { mount: mount, version: '1.0.0' };
})(window);
